/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from "@angular/core";
import BaseService from "@services/base.service";
import * as XLSX from "xlsx";

/**
 * A variant of BaseService that requires an initial value.
 *
 * This is where the initial application's information is stored.
 *
 * @class DataStoreService
 * @augments {BaseService<any>}
 */
@Injectable({
  providedIn: "root",
})
export class DataStoreService extends BaseService<any> {
  /** @internal */
  private _dataStore: any = {};

  /**
   * Loads the spreadsheet information.
   *
   * @returns {Promise<void>}  {Promise<void>}
   */
  loadData(): Promise<void> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      const reader: FileReader = new FileReader();
      const template = "all data";
      const sheet = await fetch(`/assets/data/${template}.xlsx`).then((res) => {
        return res.blob().then((res) => res);
      });

      const target = sheet;
      this._dataStore["filename"] = target;

      reader.onload = (e: any) => {
        const binaryString: string = e.target.result;

        const workBook: XLSX.WorkBook = XLSX.read(binaryString, {
          type: "binary",
        });

        // eslint-disable-next-line prefer-const
        for (let [i] of workBook.SheetNames.entries()) {
          const workSheetName: string = workBook.SheetNames[i];
          const workSheet: XLSX.WorkSheet = workBook.Sheets[workSheetName];
          const data = XLSX.utils.sheet_to_json(workSheet, { raw: true });

          this._dataStore[workSheetName] = data;
        }

        this._isEmpty = false;
        resolve();
      };

      reader.readAsBinaryString(target);
    });
  }

  /**
   * Returns the information stored on the DataStore service.
   *
   * @returns {any} the DataStore.
   */
  getData(): any {
    return this._dataStore;
  }

  /**
   * Determines whether the DataStore service is empty.
   *
   * @returns {boolean} true or false as appropriate.
   */
  override isEmpty(): boolean {
    return this._isEmpty;
  }
}
